export let isUndefined = function (obj) {
  return obj === void 0
}
// function for dynamic sorting
export let sortBy = function (param) {
  return function (a, b) {
    return a[param] - b[param];
  }
}

export let removeSpace = function (param) {
  return param.replace(/\s/g, '');
}

export let spaceToHyphen = function (param) {
  return param.replace(/\s/g, '-');
}

export let onlyAphaNumeric = function (param) {
  return param.replace(/[^a-z0-9]/gi, '-');
}

// check if value is empty, null, 'null', undefined, 'undefined'
export let isEmpty = function (value) {
  if (
    value === null
    || value == 'null'
    || value == 'undefined'
    || typeof value == 'undefined'
  ) {
    return true;
  }
  return false;
}

export const flagChecker = (str) => {
  if (str === "" || typeof str === undefined) {
    return false;
  }
  return (str === "1");
}

//This function is top evaluate if the value from the config is true or false and returns undefined if no config is found
//add true of false in BO
export const toBoolean = (str: string): boolean => {
  if(str === undefined) return undefined;
  if (str === "false") return false;
  return Boolean(str);
};

export const stringToNumber = (str) => {
  const number = parseFloat(str);
  return isNaN(number) ? undefined : number;
}

